import ProductComponent from '../product/ProductComponent';
import FilterControlComponent from '../filter/filter-control/FilterControlComponent';
import FilterMenuComponent from '../filter/filter-menu/FilterMenuComponent';
import { FC, useEffect, useState } from 'react';
import { Product } from '../../common/model';
import { TopBubblesSectionComponent } from '../TopBubblesSection/TopBubblesSectionComponent';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/AppReducer';
import { useWindowSize } from '../../hooks/useWindowSize';
import { useCallback } from 'react';
import { AppActions } from '../../redux/AppActions';
import { FilterErrorComponent } from '../FilterError/FilterErrorComponent';
import { FilterType, FilterVM, ScreenType, viewModeType } from '../../common/view-model';
import './ProductListComponent.scss';
import ProductListLoadingComponent from './productListLoading/ProductListLoadingComponent';
import { ProductListSkeletonComponent } from './productListLoading/ProductListSkeletonComponent/ProductListSkeletonComponent';
import { CategoryBreadcrumbComponent } from '../filter/category-breadcrumb/CategoryBreadcrumbComponent';
import { publicProductDiscoveryActions } from '../../common/constants';
import { useAppDispatch } from '../../redux/store';
import { FilterActions } from '../../redux/FilterActions';
import { createPortal } from 'react-dom';
interface IProductListComponentProps {
	products: Product[];
	viewMode: string;
	initLoading: Boolean;
	infiniteLoading: Boolean;
	totalCount: number;
	// fetchMoreData: () => void;
	mobileFilterPanelRef?: React.RefObject<HTMLDivElement>;
}

const ProductListComponent: FC<IProductListComponentProps> = ({
	products,
	viewMode,
	initLoading,
	infiniteLoading,
	totalCount,
	// fetchMoreData,
	mobileFilterPanelRef
}: IProductListComponentProps) => {
	const searchTerm = useSelector((state: RootState) => state.appState.searchState?.searchTerm);
	const searchTermText = `Results for '${searchTerm?.name}'`;
	const allCateogriesText = 'All Categories';
	const dispatch = useAppDispatch();
	const size = useWindowSize();
	const [productList, setProductList] = useState(products);
	const [showFilterPanel, setShowFilterPanel] = useState<boolean>(true);
	const initialProductsLength = viewMode === 'grid' ? 12 : 16;
	// const mobileScrollThreshold = 1500;
	// const otherScreenScrollThreshold = 0;
	const [productLength, setProductLength] = useState<number>(initialProductsLength);
	const [loadableProducts, setLoadableProducts] = useState<Product[]>(
		products.slice(0, initialProductsLength)
	);
	const [deviceViewMode, setDeviceViewMode] = useState<viewModeType>(
		size.width > 768 ? viewModeType.DESKTOP : viewModeType.MOBILE
	);
	const isLoading = useSelector((state: RootState) => state.appState.isLoadingData);
	const storeState = useSelector((state: RootState) => state.appState.storeState);
	// const [canLoadMore, setCanLoadMore] = useState<boolean>(true);
	const selectedCategory = useSelector(
		(state: RootState) => state.appState.filterState?.selectedCategory
	);
	const selectedFilters = useSelector(
		(state: RootState) => state.appState.filterState?.selectedFilters
	);
	const uniqueSelectedFilters = selectedFilters?.filter(
		(filter, index, self) => self.findIndex(f => f.id === filter.id) === index
	);
	const favoriteProducts = useSelector(
		(state: RootState) => state.appState.userState?.favoriteProducts || []
	);
	const deviceScreen = useSelector((state: RootState) => state.appState.deviceScreen || undefined);
	const [lastCategoryFilter, setLastCategoryFilter] = useState<FilterVM | undefined>(
		selectedFilters
			?.filter(
				item =>
					item.type === FilterType.CATEGORY ||
					item?.type === FilterType.NEW_TO_BEACON ||
					item?.type === FilterType.WHATS_NEW ||
					item?.type === FilterType.NEW_TO_MARKET ||
					item?.type === FilterType.NEXTY_FINALISTS
			)
			.pop()
	);
	const setFilterPanelClickOutside = (onClickOutside: Function) =>
		dispatch(FilterActions.addCloseFilterFunctionRef(onClickOutside));

	const clearModalContent = () => dispatch(AppActions.setModalContent(undefined));

	const setShowFilterMobilePanel = (show: boolean) =>
		dispatch(FilterActions.setIsMobileFilterOpen(show));

	const setCurrentFilterOpenIndex = (index?: number) =>
		dispatch(FilterActions.setCurrentFilterOpenIndex(index));

	const showPageTitleCallback = useCallback(
		() => dispatch(AppActions.setAppTitle(undefined)),
		[dispatch]
	);

	window.onbeforeunload = function () {
		window.scrollTo(0, 0);
	};

	const hasData =
		storeState?.totalCount !== undefined && !initLoading && storeState.filters !== undefined;

	const [showMobileFilterPanel, setShowMobileFilterPanel] = useState<boolean>(
		deviceViewMode === viewModeType.MOBILE && !showFilterPanel
	);
	const onFilterPanelOutsiteClick = async () => {
		const bodyRef = document.getElementsByTagName('body')[0] as HTMLElement;
		bodyRef!.style.overflow = 'auto';
		setAnimation('animated-hide');
		await new Promise(r => setTimeout(r, 500));
		setShowFilterPanel(false);
		clearModalContent();
	};
	const [animation, setAnimation] = useState<string | undefined>('animated-open');
	const handleClosePanel = async (miliseconds: number) => {
		if (deviceScreen === ScreenType.TABLET) {
			setAnimation('animated-hide');
			await new Promise(r => setTimeout(r, miliseconds));
			setShowFilterPanel(false);
		} else {
			setAnimation(undefined);
			setShowFilterPanel(false);
		}
		setCurrentFilterOpenIndex && setCurrentFilterOpenIndex(undefined);
	};
	const handleOpenPanel = () => {
		setAnimation('animated-open');
		setShowFilterPanel(true);
	};

	useEffect(() => {
		// const savedPosition = parseInt('' + sessionStorage.getItem('scrollPosition'), 10);
		// if (savedPosition > 0) {
		// 	setProductList(products);
		// 	setTimeout(() => {
		// 		window.scrollTo(0, savedPosition);
		// 		sessionStorage.removeItem('scrollPosition');
		// 	}, 200);
		// 	return;
		// }
		setProductList(products);
	}, [products]);

	useEffect(() => {
		setProductLength(viewMode === 'grid' ? 12 : 16);
	}, [viewMode]);

	useEffect(() => {
		setLoadableProducts(products.slice(0, productLength));
	}, [products, productLength]);

	useEffect(() => {
		if (size.width < 768) {
			setDeviceViewMode(viewModeType.MOBILE);
		} else {
			setDeviceViewMode(viewModeType.DESKTOP);
		}
	}, [size]);
	useEffect(() => {
		showPageTitleCallback();
	}, []);
	useEffect(() => {
		window.onpopstate = () => {
			setProductLength(12);
			setLoadableProducts(products.slice(0, productLength));
		};
	}, [loadableProducts, productLength, products]);

	useEffect(() => {
		if (deviceScreen === ScreenType.TABLET) {
			setShowFilterPanel(false);
			setFilterPanelClickOutside(onFilterPanelOutsiteClick);
		} else {
			setShowFilterPanel(true);
			setAnimation('animated-open');
		}
	}, [deviceScreen]);
	useEffect(() => {
		setShowFilterMobilePanel(showMobileFilterPanel);
	}, [showMobileFilterPanel]);
	// const handleScroll = useCallback(() => {
	// 	if (
	// 		window.innerHeight + document.documentElement.scrollTop <=
	// 			document.documentElement.offsetHeight -
	// 				(deviceScreen === ScreenType.MOBILE
	// 					? mobileScrollThreshold
	// 					: otherScreenScrollThreshold) ||
	// 		infiniteLoading
	// 	) {
	// 		return;
	// 	}
	// 	canLoadMore && fetchMoreData();
	// }, [canLoadMore, fetchMoreData, infiniteLoading]);

	// useEffect(() => {
	// 	window.addEventListener('scroll', handleScroll);
	// 	return () => window.removeEventListener('scroll', handleScroll);
	// }, [infiniteLoading, handleScroll]);

	// useEffect(() => {
	// 	const validateCanLoad =
	// 		storeState?.products &&
	// 		storeState.totalCount &&
	// 		storeState?.products.length < storeState?.totalCount;
	// 	if (validateCanLoad) {
	// 		setCanLoadMore(true);
	// 	} else {
	// 		setCanLoadMore(false);
	// 	}
	// }, [storeState?.products, storeState?.totalCount]);
	//Temporarily commented this BP - 1216
	// useEffect(() => {
	// 	if (window.localStorage.getItem('discover') !== 'done' && currentEvent) {
	// 		showEventModal();
	// 	}
	// }, [currentEvent, showEventModal]);
	useEffect(() => {
		setLastCategoryFilter(
			selectedFilters
				?.filter(
					item =>
						item.type === FilterType.CATEGORY ||
						item?.type === FilterType.NEW_TO_BEACON ||
						item?.type === FilterType.WHATS_NEW ||
						item?.type === FilterType.NEW_TO_MARKET ||
						item?.type === FilterType.NEXTY_FINALISTS
				)
				.pop()
		);
	}, [selectedFilters]);
	const isSkeletonLoading = !hasData || isLoading;

	useEffect(() => {
		const body = document.body;
		if (isSkeletonLoading) {
			const prev = body.style.overflow;
			body.style.overflow = 'hidden';
			return () => {
				body.style.overflow = prev;
			};
		}
	}, [isSkeletonLoading]);

	return (
		<>
			{hasData ? (
				<>
					{showMobileFilterPanel ? (
						<FilterMenuComponent
							handelClosePanel={() => setShowMobileFilterPanel(false)}
							viewMode={deviceViewMode}
							mobileFilterPanelRef={mobileFilterPanelRef}
						/>
					) : (
						<>
							<div className='category-title-container'>
								<span className='category-title'>
									{searchTerm ? searchTermText : selectedCategory || allCateogriesText}
								</span>
							</div>
							{(!searchTerm || (searchTerm && selectedFilters?.length !== 0)) && (
								<CategoryBreadcrumbComponent elements={lastCategoryFilter?.breadCrumbElements} />
							)}
							<div
								className={`${showFilterPanel ? 'products-wrapper ' : ''}${
									searchTerm ? 'search-wrapper' : ''
								}`}
							>
								{deviceViewMode === viewModeType.DESKTOP && showFilterPanel && (
									<div className={animation}>
										<FilterMenuComponent
											handelClosePanel={() => handleClosePanel(500)}
											viewMode={deviceViewMode}
										/>
									</div>
								)}
								<div className='products-box'>
									<div className='col'>
										<div className='row'>
											<FilterControlComponent
												showAllFiltersButton={
													!showFilterPanel || deviceViewMode === viewModeType.MOBILE
												}
												productsLength={totalCount}
												showAllFiltersHandler={
													deviceViewMode === viewModeType.MOBILE
														? () => setShowMobileFilterPanel(true)
														: () => handleOpenPanel()
												}
												showClearAllFiltersButton={
													!!((selectedFilters && selectedFilters.length > 0) || searchTerm)
												}
												deviceViewMode={deviceViewMode}
											/>
											{selectedFilters && selectedFilters.length > 0 && (
												<TopBubblesSectionComponent
													bubbles={uniqueSelectedFilters}
													showFilterPanel={showFilterPanel}
													handleOpenPanel={handleOpenPanel}
													deviceScreen={deviceScreen}
												/>
											)}
										</div>
										<div data-testid='product-list-component' className='row'>
											{!isLoading && hasData ? (
												productList.length !== 0 ? (
													<div
														className={`product-list ${
															showFilterPanel ? 'expanded' : 'collapsed'
														} `}
													>
														<div>
															{productList.map((product, index) => {
																return (
																	<ProductComponent
																		key={index}
																		product={product}
																		favorite={favoriteProducts?.some(
																			favorite => favorite.pid === product?.id
																		)}
																		anonymousEventName={
																			publicProductDiscoveryActions.CLICK_HEART_ICON
																		}
																	/>
																);
															})}
														</div>
													</div>
												) : (
													<FilterErrorComponent type={searchTerm ? 'search' : 'filter'} />
												)
											) : (
												<ProductListSkeletonComponent
													viewMode={showFilterPanel ? 'expanded' : 'collapsed'}
												/>
											)}
											{infiniteLoading && (
												<ProductListSkeletonComponent
													viewMode={showFilterPanel ? 'expanded' : 'collapsed'}
												/>
											)}
										</div>
									</div>
								</div>
							</div>
						</>
					)}
				</>
			) : (
				<ProductListLoadingComponent
					data-testid='loading-state'
					deviceScreen={deviceScreen}
					initLoading={true}
				/>
			)}
			{isSkeletonLoading &&
				createPortal(
					<div className='skeleton-loader'>
						<div className='skeleton-loader-shell'>
							<ProductListLoadingComponent
								data-testid='loading-state'
								deviceScreen={deviceScreen}
								initLoading={!hasData}
							/>
						</div>
					</div>,
					document.body
				)}
		</>
	);
};

export default ProductListComponent;
